import { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PromotionPage from './PromotionPage.component';

export class PromotionPageContainer extends PureComponent {
    render() {
        return <PromotionPage { ...this.props } />;
    }
}

export default withRouter(PromotionPageContainer);
